import AppContextProvider from "./AppContextProvider";
import Ladder from "./ladder/Ladder";
import GraphSection from "./graph/GraphSection";
import WinnerStyles from "./winner/WinnerStyles";

function App() {
  return (
    <AppContextProvider>
      <WinnerStyles />
      <Ladder />
      <GraphSection />
    </AppContextProvider>
  );
}

export default App;
